/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolbar_Secondary_Undo_TitleInputs */

const en_toolbar_secondary_undo_title = /** @type {(inputs: Toolbar_Secondary_Undo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undo`)
};

const fr_toolbar_secondary_undo_title = /** @type {(inputs: Toolbar_Secondary_Undo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const de_toolbar_secondary_undo_title = /** @type {(inputs: Toolbar_Secondary_Undo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rückgängig machen`)
};

const it_toolbar_secondary_undo_title = /** @type {(inputs: Toolbar_Secondary_Undo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disfare`)
};

const ru_toolbar_secondary_undo_title = /** @type {(inputs: Toolbar_Secondary_Undo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отменить`)
};

const es_toolbar_secondary_undo_title = /** @type {(inputs: Toolbar_Secondary_Undo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deshacer`)
};

const zh_cn2_toolbar_secondary_undo_title = /** @type {(inputs: Toolbar_Secondary_Undo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`撤销`)
};

const ja_toolbar_secondary_undo_title = /** @type {(inputs: Toolbar_Secondary_Undo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元に戻す`)
};

const hi_toolbar_secondary_undo_title = /** @type {(inputs: Toolbar_Secondary_Undo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्ववत`)
};

const pt_pt2_toolbar_secondary_undo_title = /** @type {(inputs: Toolbar_Secondary_Undo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desfazer`)
};

/**
* | output |
* | --- |
* | "Undo" |
*
* @param {Toolbar_Secondary_Undo_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toolbar_secondary_undo_title = /** @type {((inputs?: Toolbar_Secondary_Undo_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolbar_Secondary_Undo_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_toolbar_secondary_undo_title(inputs)
	if (locale === "de") return de_toolbar_secondary_undo_title(inputs)
	if (locale === "it") return it_toolbar_secondary_undo_title(inputs)
	if (locale === "ru") return ru_toolbar_secondary_undo_title(inputs)
	if (locale === "es") return es_toolbar_secondary_undo_title(inputs)
	if (locale === "zh-CN") return zh_cn2_toolbar_secondary_undo_title(inputs)
	if (locale === "ja") return ja_toolbar_secondary_undo_title(inputs)
	if (locale === "hi") return hi_toolbar_secondary_undo_title(inputs)
	if (locale === "pt-PT") return pt_pt2_toolbar_secondary_undo_title(inputs)
	return en_toolbar_secondary_undo_title(inputs)
});